import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { TeamActions as TA } from './team.action';
import { Team } from './../../models/dto/team.model';
import { TeamService } from 'app/modules/teams/team.service';
import { catchError } from 'rxjs/operators';
import { of, tap } from 'rxjs';
import { patch, updateItem } from '@ngxs/store/operators';

// Inherit the parent state model with correct entity type.
export class TeamStateModel {
  currentTeam: Team;
  loading: boolean;
  expires: number;
  teams: Team[];
}

@State<Partial<TeamStateModel>>({
	name: 'team',
	defaults: {
    teams: [],
    loading: false,
  }
})

@Injectable()
export class TeamState {

  @Selector()
  static currentTeam(state: TeamStateModel) {
    return state.currentTeam;
  }

  @Selector()
  static teams(state: TeamStateModel) {
    return state.teams;
  }

  @Selector()
  static loading(state: TeamStateModel) {
    return state.loading;
  }

  // DI creates a concrete service that implements AbstractCrudService for
  // use by the parent EntityState.
	constructor(
    private teamService: TeamService,
  ) {}

  // Implement common CRUD actions by delegating to parent class.
  @Action(TA.Get)
	taGet(
    ctx: StateContext<TeamStateModel>,
    { id }: TA.Get
  ) {
    ctx.patchState({loading: true});
    return this.teamService.get(id).pipe(
      catchError(err => {
        ctx.patchState({loading: false});
        return of(err);
      }),
      tap(team => {
        ctx.setState(patch({
          teams: updateItem(stateTeam => stateTeam.id === id, team),
          currentTeam: team,
        }));
      }),
    );
  }

  @Action(TA.GetTeams)
	taGetIndex(
    ctx: StateContext<TeamStateModel>,
    { }: TA.GetTeams) {
    ctx.patchState({loading: true});
    return this.teamService.getIndex().pipe(
      catchError(err => {
        ctx.patchState({loading: false});
        return of(err);
      }),
      tap( teams => {
        ctx.patchState({
          teams,
          loading: false,
        });
      })
    );
  }
}
